import { render, staticRenderFns } from "./AuctionFormReverseAntiSnipe.vue?vue&type=template&id=b0a0d7bc&scoped=true"
import script from "./AuctionFormReverseAntiSnipe.vue?vue&type=script&lang=js"
export * from "./AuctionFormReverseAntiSnipe.vue?vue&type=script&lang=js"
import style0 from "./AuctionFormReverseAntiSnipe.vue?vue&type=style&index=0&id=b0a0d7bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0a0d7bc",
  null
  
)

export default component.exports